<div class="mt-4 mb-4" *ngIf="purchaseOrder">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/order']">Commandes</button></li>
    <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" disabled>{{ purchaseOrder.number }}</button></li>
  </ol>
</div>

<div class="pb-2 bg-white rounded shadow-sm container-fluid" *ngIf="purchaseOrder">
  <div class="mb-3 d-flex row text-center">
    <div class="p-2 col-xl">
      <h5>{{ purchaseOrder.supplier.name }}</h5>
      <div>
        <purchase-order-status [status]="purchaseOrder.status"></purchase-order-status>
      </div>
      <div>
        Commande {{ purchaseOrder.number }}
      </div>
      <div>{{ purchaseOrder.details.length }} référence(s)</div>
      <div *ngIf="invoices != undefined && invoices.length != 0">
        <strong>Factures:</strong>
        <button class="btn btn-sm btn-link" *ngFor="let invoice of invoices" [routerLink]="['/purchase/invoice', invoice.id]" >{{ invoice.supplierInvoiceNumber }}</button>
      </div>
    </div>
    
    <div class="p-2 col-xl">
      <div>
        Mode de livraison:
        <ng-container *ngIf="purchaseOrder.submitDate">
          <span class="badge badge-secondary" [ngSwitch]="purchaseOrder.deliveryMode">
            <delivery-mode [deliveryMode]="purchaseOrder.deliveryMode"></delivery-mode>
          </span>
        </ng-container>

        <ng-container *ngIf="!purchaseOrder.submitDate">
          <a class="btn btn-sm btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
            <delivery-mode [deliveryMode]="purchaseOrder.deliveryMode"></delivery-mode>
          </a>
  
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="updateDeliveryMode('DELIVERY')">Livraison</a>
            <a class="dropdown-item" (click)="updateDeliveryMode('PICKUP')">Ramassage</a>
            <a class="dropdown-item" (click)="updateDeliveryMode('REPRESENTATIVE')">Représantant</a>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="p-2 col-xl">
      <div *ngIf="purchaseOrder.submitDate"> 
        <button class="btn btn-sm btn-link" [routerLink]="['/purchase/order/', purchaseOrder.number, 'needa', 'ORDER']">
          Commande Needa
        </button>
      </div>
      <div *ngIf="purchaseOrder.ackDate">
        <button class="btn btn-sm btn-link" [routerLink]="['/purchase/order/', purchaseOrder.number, 'needa', 'ORDER_ACK']">
          Avis de réception Needa
        </button>
      </div>
      <div *ngIf="purchaseOrder.confirmDate">
        <button class="btn btn-sm btn-link" [routerLink]="['/purchase/order/', purchaseOrder.number, 'needa', 'ORDER_CONFIRMATION']">
          Confirmation Needa
        </button>
      </div>
    </div>

    <div class="p-2 col-xl-4">
      <div>Ouverte le <strong>{{ purchaseOrder.creationDate | date: 'medium' }}</strong></div>
      <div *ngIf="purchaseOrder.submitDate">Soumise le <strong>{{ purchaseOrder.submitDate | date: 'medium' }}</strong></div>
      <div *ngIf="purchaseOrder.ackDate">Traité par le fournisseur le <strong>{{ purchaseOrder.ackDate | date: 'medium' }}</strong></div>
      <div *ngIf="purchaseOrder.confirmDate">Confirmée par le fournisseur le <strong>{{ purchaseOrder.confirmDate | date: 'medium' }}</strong></div>
      <div *ngIf="purchaseOrder.shippedDate">Expédiée le <strong>{{ purchaseOrder.shippedDate | date: 'medium' }}</strong></div>
      <div *ngIf="purchaseOrder.canceledDate">Annulée le <strong>{{ purchaseOrder.canceledDate | date: 'medium' }}</strong></div>
    </div>
  </div>

  <div class="mb-3 alert alert-warning text-center" *ngIf="needaConfig != undefined && !needaConfig.valid || needaConfigMissing">
    <strong>Attention!</strong> Il ne sera pas possible de passer de commande chez ce fournisseur tant les<button class="btn btn-sm btn-link" [routerLink]="['/inventory/supplier/', purchaseOrder.supplier.id]" fragment="needa">informations needa</button>ne sont pas configurées!
  </div>

  <div class="mb-3 input-group" *ngIf="purchaseOrder.status == 'DRAFT'">
    <input type="text" class="form-control" placeholder="Recherche référence" [attr.disabled]="loading ? 'DISABLED' : null" (keyup)="onSearchKeyup($event)" [(ngModel)]="query" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button" [attr.disabled]="loading ? 'DISABLED' : null" (click)="search()">
        <i *ngIf="!searchInProgress" class="bi bi-search"></i>
        <span *ngIf="searchInProgress" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </button>
    </div>
  </div>

  <table class="table table-sm text-center">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th class="text-left">Référence</th>
        <th>Prix de vente</th>
        <th>Quantité</th>
        <th>Inventaire</th>
        <th>&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let detail of purchaseOrder.details">
        <td><reference-image [reference]="detail.reference"></reference-image></td>
        <td class="text-left">
          <div>
            {{ detail.reference.title }}
            <a class="ml-2" [routerLink]="['/inventory/reference', detail.reference.isbn]" target="_blank">
              <i class="bi bi-card-heading"></i>
            </a>
          </div>
          <div>{{ detail.reference.isbn }}</div>
          <div>{{ detail.reference.publisher }}</div>
        </td>
        <td>{{ detail.reference.supplierReferences[0].retailPrice / 100 | number:'1.2-2' }}</td>
        <td><input type="number" min="1" max="999" class="form-control text-center ml-1 mr-1 align-self-center" [attr.disabled]="purchaseOrder.status != 'DRAFT' || loading ? 'DISABLED' : null" [(ngModel)]="detail.quantity" (ngModelChange)="updateQuantity(detail)" /></td>
        <td><reference-inventory [reference]="detail.reference"></reference-inventory></td>
        <td>
          <button class="btn btn-sm btn-outline-secondary" [attr.disabled]="loading ? 'DISABLED' : null" (click)="removeDetail(detail)">
            <span [attr.class]="detail.deleting ? 'spinner-border spinner-border-sm' : 'bi bi-trash'"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <!--
  <div class="p-3 mb-3 bg-light rounded shadow-sm" *ngFor="let detail of purchaseOrder.details">
    <div class="d-flex small lh-sm">
      <div class="align-self-center text-center">
        <reference-image [reference]="detail.reference"></reference-image>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg">
            <div>
              {{ detail.reference.title }}
              <a class="ml-2" [routerLink]="['/inventory/reference', detail.reference.isbn]" target="_blank">
                <i class="bi bi-card-heading"></i>
              </a>
            </div>
            <div>{{ detail.reference.isbn }}</div>
            <div>{{ detail.reference.publisher }}</div>
          </div>
          <div class="col-lg-2 col-xl-2 pr-3 align-self-center mt-1 mb-1">{{ detail.reference.supplierReferences[0].supplier.name }}</div>
          <div class="col-lg pl-3 pr-3 align-self-center d-flex">
            <div class="align-self-center text-nowrap">{{ detail.reference.supplierReferences[0].retailPrice / 100 | number:'1.2-2' }} $ x</div>
            <input type="number" min="1" max="999" class="form-control ml-1 mr-1 align-self-center" [attr.disabled]="loading ? 'DISABLED' : null" [(ngModel)]="detail.quantity" (ngModelChange)="updateQuantity(detail)" />
            <div class="text-nowrap d-flex">
              <span class="align-self-center">=</span>
              <div class="total align-self-center ml-auto text-right"> {{ detail.reference.supplierReferences[0].retailPrice * detail.quantity / 100 | number:'1.2-2' }} $</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-auto align-self-center">
        <button class="btn btn-sm btn-outline-secondary" [attr.disabled]="loading ? 'DISABLED' : null" (click)="removeDetail(detail)"><span class="bi bi-trash"></span></button>
      </div>
    </div>
  </div>
-->

  <div class="pb-3 d-flex" *ngIf="purchaseOrder.status == 'DRAFT'">
    <button class="btn btn-sm btn-danger" [attr.disabled]="loading ? 'DISABLED' : null" (click)="cancel()">Annuler</button>
    <button class="btn btn-sm btn-success ml-auto" (click)="submitPurchaseOrder()" [attr.disabled]="needaConfig == undefined || !needaConfig.valid || purchaseOrder.details.length == 0 || loading ? 'DISABLED' : null">Envoyer la commande</button>
  </div>
</div>